import { Store, select } from '@ngrx/store';
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import { AppState } from '../../reducers';
import {
  selectReasonsInStore,
  selectReasonsPageLoading,
  selectReasonsShowInitWaitingMessage,
} from '../_selectors/reason.selectors';

export class ReasonsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectReasonsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectReasonsShowInitWaitingMessage));

    this.store.pipe(select(selectReasonsInStore)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
